<template>
  <div
    data-qa-base="base-alert"
    class="base-alert d-flex align-start rounded-sm"
    :style="{
      backgroundColor: currentColors.background,
      borderLeftColor: currentColors.border,
    }"
  >
    <div
      v-if="icon"
      class="base-alert__icon"
      :class="icon"
      :style="{ color: currentColors.icon }"
    />
    <div
      data-qa="base-alert-content"
      class="base-alert__content py-2 pl-2 pr-4"
    >
      <div
        v-if="title"
        data-qa="base-alert-title"
        class="text-subtitle-2 text--text"
      >
        {{ title }}
      </div>
      <div
        v-if="text || $slots.default"
        data-qa="base-alert-text"
        class="text-body-2 text--text"
      >
        {{ text }}
        <slot />
      </div>
      <template v-if="linkText">
        <a
          v-if="href"
          data-qa="base-alert-link"
          class="text-link-2 primary--text cursor-pointer link-decoration-underline"
          target="_blank"
          rel="noopener noreferrer"
          :href="href"
          @click="emit('click:link')"
        >{{ linkText }}</a>
        <button
          v-else
          data-qa="base-alert-link"
          class="text-link-2 primary--text cursor-pointer link-decoration-underline"
          type="button"
          @click="emit('click:link')"
        >
          {{ linkText }}
        </button>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import styleVars from 'www/themes/doctors/common/variables-export.module.scss'

/**
 * Нужна прозрачность в N%. В alpha-канале используется hex-формат (FF),
 * поэтому ищем N% от 255 и переводим в hex.
 */
const getAlphaChannel = (opacity: number) => `0${Math.round(255 * opacity).toString(16)}`
  .slice(-2)
  .toUpperCase()
const alphaChannels = {
  background: getAlphaChannel(0.12),
  border: getAlphaChannel(0.4),
}

const props = withDefaults(defineProps<{
  color: string
  icon?: string
  title?: string
  text?: string
  href?: string
  linkText?: string
  coloredBorder?: boolean
}>(), {
  icon: 'ui-icon-circle-warning',
  title: '',
  text: '',
  href: '',
  linkText: '',
  coloredBorder: false,
})

type Emits = {
  (_e: 'click:link'): void,
}

const emit = defineEmits<Emits>()

const currentColors = computed(() => {
  const styleVar = styleVars[props.color]

  /*
  * TODO: для icon заменить значение на props.color, когда будут добавлены классы глобальных цветов,
  * и заменить style на class для currentColors.icon
  * */
  return props.coloredBorder
    ? {
      icon: styleVar,
      border: styleVar,
      background: undefined,
    }
    : {
      icon: styleVar,
      border: `${styleVar}${alphaChannels.border}`,
      background: `${styleVar}${alphaChannels.background}`,
    }
})
</script>

<style lang="scss" scoped>
.base-alert {
  border-left-width: 6px;
  border-left-style: solid;

  &__icon {
    margin: 6px 6px 6px 10px;
  }

  &__content > *:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>
